import { Anagrafica } from './anagrafica';
import { Collaboratore } from './collaboratore';
import { DocumentoIdentita } from './documento-identita';
import { Trascodifica } from './trascodifica';

export class Profilo {
  id: number;
  dataCreazione: Date;
  dataModifica: Date;
  username: string;
  password: string;
  idDocumentoIdentita: number;
  documentoIdentita: DocumentoIdentita;
  nomeFileDocumentoIdentita: string;
  nomeFileVisuraCamerale: string;
  gRecaptchaResponse: string;
  tipologia: Trascodifica;
  idTipologia: number;
  anagrafica: Anagrafica;
  accessoAppAutorizzato: boolean;
  accessoImmobileAutorizzato: boolean;
  importoMassimo: number;
  completato: boolean;
  collaboratore: Collaboratore;
  cancellato: boolean;
  
  // Utilizzato per il autocomplete
  itemName: string;

  constructor (){
    this.anagrafica = new Anagrafica();
    this.documentoIdentita = new DocumentoIdentita();
  }

}



// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/models/profilo.ts